import { useState, useCallback } from 'react';

/**
 * useDisclosure - replacement for Chakra UI's useDisclosure hook
 */
export function useDisclosure(defaultIsOpen = false) {
  const [isOpen, setIsOpen] = useState(defaultIsOpen);

  const onOpen = useCallback(() => setIsOpen(true), []);
  const onClose = useCallback(() => setIsOpen(false), []);
  const onToggle = useCallback(() => setIsOpen((v) => !v), []);

  return { isOpen, onOpen, onClose, onToggle };
}
